import { useEffect, useState, useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import LoadingSpinner from '../common/loading/LoadingSpinner'
import Note from '../../components/Note'
import { NoteType } from '../../enums/NoteType'
import { Pages } from '../../Pages'
import { storeInviteTarget } from '../../auth/inviteTarget'

export default function Invite(): React.JSX.Element {
    const navigate = useNavigate()
    const [error, setError] = useState<string | null>(null)
    const [redirecting, setRedirecting] = useState(false)

    const run = useCallback(async () => {
        try {
            const params = new URLSearchParams(window.location.search)
            const resetUrl = params.get('resetUrl')
            const target = params.get('target')

            if (
                target &&
                (!target.startsWith('/') || target.startsWith('//'))
            ) {
                setError('Invalid target path')
                return
            }
            storeInviteTarget(target || undefined)

            if (resetUrl) {
                setRedirecting(true)
                window.location.href = resetUrl
                return
            }

            // Legacy invite links are no longer supported
            setError(
                'This invite link is no longer valid. Please request a new magic link from the login screen.',
            )
        } catch (e: any) {
            console.error('Invite flow error', e)
            setError('Unable to process invite')
        }
    }, [])

    useEffect(() => {
        run()
    }, [run])

    if (error) {
        return (
            <div className="p-4">
                <Note type={NoteType.ERROR}>{error}</Note>
                <div className="mt-4 text-sm">
                    <button
                        className="underline"
                        onClick={() => navigate(Pages.Login)}
                    >
                        Go to login
                    </button>
                </div>
            </div>
        )
    }

    return (
        <div className="flex flex-col items-center justify-center min-h-screen">
            <LoadingSpinner />
            <p className="mt-4 text-gray-600 text-sm">
                {redirecting
                    ? 'Redirecting to secure password setup...'
                    : 'Preparing invite...'}
            </p>
        </div>
    )
}
